import axios from 'axios';

const isAbortedRequest = (error, signal) => (
  Boolean(signal?.aborted)
  || error?.name === 'AbortError'
  || error?.name === 'CanceledError'
  || error?.code === 'ERR_CANCELED'
  || Boolean(axios.isCancel?.(error))
);

export default isAbortedRequest;
